<template>
  <div>
    <div class="container">
      <div class="login">
        <h2 class="login-title">欢迎来到智能日历</h2>
        <h6 class="login-sub-title">需要绑定手机号</h6>
        <form>
          <div class="input-group">
            <label class="name">手机号</label>
            <input type="number" value=“” v-model="phoneNumber" placeholder="请输入手机号"/>
          </div>
          <div class="input-group">
            <label class="name">验证码</label>
            <input type="number" class="auth-input" value=“” v-model="authCode" placeholder="请输入验证码"/>
            <button type="button" class="btn strokeGery auth" @click="getCode()" :disabled="reGetCode">{{codeBtnText}}</button>
          </div>
        </form>
        <cube-button class="login-btn" @click="goLogin()">登  录</cube-button>
      </div>
    </div>
    <p>点击登录按键即代表阅读并同意<a href="javascript:;" @click="goAgreement">《秒秒测智能健康日历服务协议》</a></p>
  </div>
</template>
<script>
import axios from 'axios'
import Common from '../../assets/js/common.js'
var api = process.env.BASE_URL
export default {
  name: 'Login',
  data () {
    return {
      phoneNumber: '',
      authCode: '',
      reGetCode: false,
      codeBtnText: '获取验证码'
    }
  },
  mounted () {
    Common.setTitle('绑定手机')
    let _this = this
    window.history.pushState(null, null, '#/login')
    window.removeEventListener('popstate', _this.goLink)
    window.addEventListener('popstate', _this.goLink)
    _this.phoneNumber = localStorage.getItem('max_phoneNumber')
  },
  destroyed () {
    setTimeout(() => {
      let _this = this
      window.removeEventListener('popstate', _this.goLink)
    }, 1000)
  },
  watch: {
    authCode (newValue) {
      if (newValue.length > 4) {
        this.authCode = newValue.substr(0, 4)
      }
    }
  },
  methods: {
    goLink () {
      window.history.pushState(null, null, '#/login')
    },
    goAgreement () {
      localStorage.setItem('max_phoneNumber', this.phoneNumber)
      this.$router.push('/Agreement')
    },
    goLogin () {
      // 验证手机号
      if (!this.verifyPhoneNum()) return
      // 验证码不为空验证
      if (this.authCode === '') {
        this.toast = this.$createToast({
          txt: '验证码不能为空',
          type: 'txt'
        })
        this.toast.show()
        return false
      }
      this.bindPhoneNumber()
    },
    // 验证手机号是否为空和格式是否正确
    verifyPhoneNum () {
      // 正则表达式，十一位数字的电话号码
      // let phoneReg = /^(0|86|17951)?(13[0-9]|15[0-9]|166|17[0-9]|18[0-9]|19[0-9]|14[57])[0-9]{8}$/
      let phoneReg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[8][8][6][9]\d{8}$|^[6]([8|6])\d{5}$/
      // 大陆加港澳台
      // let phoneReg = /^1[0-9]{10}$/
      // 不验证第二位
      // 如果手机号码输入为空，则再输入框后插入错误信息
      if (this.phoneNumber === '') {
        this.toast = this.$createToast({
          txt: '手机号不能为空',
          type: 'txt'
        })
        this.toast.show()
        return false
      }
      // 验证输入的电话号码是否是11位数字
      if (!phoneReg.test(this.phoneNumber)) {
        this.toast = this.$createToast({
          txt: '请输入正确的手机号',
          type: 'txt'
        })
        this.toast.show()
        return false
      }
      return true
    },
    // 获取验证码
    getCode () {
      if (!this.reGetCode) {
        if (this.verifyPhoneNum()) {
          // 获取验证码
          this.sendNumber()
          this.setTimer()
          this.reGetCode = true
        }
      }
    },
    // 开启定时器
    setTimer () {
      let time = 60
      time--
      this.codeBtnText = `${time}秒后重试`
      let timers = setInterval(() => {
        time--
        if (time <= 0) {
          time = 0
          this.reGetCode = false
          this.codeBtnText = '获取验证码'
          clearInterval(timers)
          return false
        }
        this.codeBtnText = `${time}秒后重试`
      }, 1000)
    },
    // 发送手机号获取验证码
    sendNumber () {
      axios.post(api + '/mmc/api/user/toke/', {
        'phonenumber': this.phoneNumber
      })
        .then(this.sendNumberSucc)
        .catch(this.sendNumberError)
    },
    sendNumberSucc (res) {
      let _res = res.data
      // alert('sendNumber' + JSON.stringify(_res))
      let result = _res.result
      if (result === 0) {
        console.log('发送成功')
      } else {
        console.log(_res.message)
      }
    },
    sendNumberError (error) {
      console.log(error)
    },
    // 绑定手机号
    bindPhoneNumber () {
      // alert(localStorage.getItem('openId'))
      axios.post(api + '/mmc/api/user/bindphone/', {
        'phonenumber': this.phoneNumber,
        'VCODE': this.authCode,
        'openid': localStorage.getItem('max_openId')
      })
        .then(this.bindPhoneNumberSucc)
        .catch(this.bindPhoneNumberError)
    },
    bindPhoneNumberSucc (res) {
      let _res = res.data
      // alert('bindNumberSucess' + JSON.stringify(_res))
      if (_res.result === 1) {
        // 绑定成功 登录
        this.login()
      } else if (_res.result === 3) {
        this.toast = this.$createToast({
          txt: '抱歉此手机号已经绑定过',
          type: 'txt'
        }).show()
        this.login()
      } else if (_res.result === 4) {
        this.toast = this.$createToast({
          txt: '验证码错误',
          type: 'txt'
        }).show()
        // this.login()
      } else {
        this.toast = this.$createToast({
          txt: '手机号绑定失败',
          type: 'txt'
        }).show()
      }
    },
    bindPhoneNumberError (error) {
      console.log(error)
    },
    // 登录
    login () {
      this.toast = this.$createToast({
        time: 0,
        txt: '正在登录',
        mask: true
      }).show()
      axios.post(api + '/mmc/api/user/login/', {
        'phonenumber': this.phoneNumber,
        'VCODE': this.authCode,
        'openid': localStorage.getItem('max_openId')
      })
        .then(this.loginSucc)
        .catch(this.loginError)
    },
    // 登录成功以后的回调函数
    loginSucc (res) {
      this.toast.hide()
      let _res = res.data
      // alert('loginSucee' + JSON.stringify(_res))
      let result = _res.result
      if (result === 0) {
        // 登录成功
        localStorage.setItem('userInfo', JSON.stringify(_res.mmcuser))
        localStorage.setItem('max_userId', _res.mmcuser.userid)
        this.$router.replace({path: '/'})
      } else if (_res.result === 4) {
        this.toast = this.$createToast({
          txt: '验证码错误',
          type: 'txt'
        })
        this.toast.show()
      } else {
        this.toast = this.$createToast({
          txt: '登录失败,' + _res.message,
          type: 'txt'
        })
      }
    },
    loginError () {
      this.toast.hide()
      this.toast = this.$createToast({
        txt: '服务器异常，登录失败',
        type: 'txt'
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.container
  padding 8.1vh 46px 0
  box-sizing border-box
  background #ffffff
  height auto
.login
  .login-title
    font-size 24px
    font-weight 200
  .login-sub-title
    font-size 16px
    padding-top 2.3vh
    color #666666
  form
    padding-top 13.1vh
  .input-group
    margin-top .42rem
    position relative
    .name
      font-size 14px
    input
      height 39px
      line-height 39px
      width 100%
      font-size 16px
      border-bottom 2px solid #c1c4c6
      box-sizing border-box
    .auth-input
      padding-right: 50%
    .auth
      position absolute
      font-size 14px
      height 25px
      line-height 25px
      bottom 8px
      background transparent
      right 0
  .login-btn
    margin-top 15vh
  .login-btn:active
    background #000000
p
  font-size 10px
  text-align center
  margin-top 2vh
</style>



// WEBPACK FOOTER //
// src/pages/Login/Login.vue